export default __webpack_public_path__ + "static/media/nextlevel.68503a9e.png";